import { put, call, takeEvery, select } from 'redux-saga/effects'
import startOfDay from 'date-fns/startOfDay'
import subMonths from 'date-fns/subMonths'

import { companyId } from '@/core/selectors/sessions'

import * as hiringAnalyticsView from '../reducks/hiringAnalytics'
import { getRates } from '@/core/apiModules/hiringAnalytics'
import { errorHandler } from '@/core/helpers/errorHelpers'
import { showSystemError, hideSystemError } from '@/core/components/SystemErrorRedux'

function* fetchQuarterRates() {
  try {
    yield put(hideSystemError())

    const id = yield select(companyId)
    const response = yield call(getRates, id, {
      rate: 'interview_request_acceptance',
      start_at: subMonths(startOfDay(new Date()), 3),
    })
    yield put(hiringAnalyticsView.fetchQuarterRatesSuccess(response))
  } catch (err) {
    const { error } = yield call(errorHandler, err)
    yield put(hiringAnalyticsView.fetchQuarterRatesError(error))

    yield put(showSystemError(error))
  }
}

export default function* watchQuarterRatesSaga() {
  yield takeEvery(hiringAnalyticsView.FETCH_QUARTER_RATES, fetchQuarterRates)
}
